// @ts-check
import ReferralDetails from './ReferralDetails';

export default ReferralDetails;
